import chemicalEngineering from "../assets/images/Dashboard/chemicalengineering.svg";
import robticsEngineering from "../assets/images/Dashboard/robotics_engineering.svg";
import productionEngineering from "../assets/images/Dashboard/production_engineering.svg";
import powerEngineering from "../assets/images/Dashboard/power_engineering.svg";
import petroleumEngineering from "../assets/images/Dashboard/petroleum_engineering.svg";
import mechanicalEngineering from "../assets/images/Dashboard/mechanical_engineering.svg";
import informationTechnology from "../assets/images/Dashboard/information_technology.svg";
import mbbs from "../assets/images/Dashboard/mbbs.svg";
import civilEngineering from "../assets/images/Dashboard/civil_engineering.svg";

const departments = {
  chemicalEngineering: "Chemical Engineering",
  robticsEngineering: "Robtics Engineering",
  productionEngineering: "Production Engineering",
  powerEngineering: "Power Engineering",
  petroleumEngineering: "petroleumEngineering",
  mechanicalEngineering: "mechanicalEngineering",
  informationTechnology: "Information Technology",
  mbbs: "mbbs",
  civilEngineering: "civilEngineering",
  electricalEngineering: "Electrical and Electronics Engineering",
};

export function getIcon(department) {

  if (department.includes(departments.chemicalEngineering)) {
    return chemicalEngineering;
  } else if (department.includes(departments.robticsEngineering)) {
    return robticsEngineering;
  } else if (department.includes(departments.productionEngineering)) {
    return productionEngineering;
  } else if (department.includes(departments.powerEngineering)) {
    return powerEngineering;
  } else if (department.includes(departments.petroleumEngineering)) {
    return petroleumEngineering;
  } else if (department.includes(departments.mechanicalEngineering)) {
    return mechanicalEngineering;
  } else if (department.includes(departments.informationTechnology)) {
    return informationTechnology;
  } else if (department.includes(departments.mbbs)) {
    return mbbs;
  } else if (department.includes(departments.civilEngineering)) {
    return civilEngineering;
  } else {
    return mechanicalEngineering;
  }
}
export function getColor(department) {
  if (department.includes(departments.chemicalEngineering)) {
    return { linerColor: "#54C741", linerBG: "#c4efbd", mainBG: "#ebfbe9" };
  } else if (department.includes(departments.robticsEngineering)) {
    return { linerColor: "#4BEBF5", linerBG: "#c4fcff", mainBG: "#ecfeff" };
  } else if (department.includes(departments.productionEngineering)) {
    return { linerColor: "#00A1F1", linerBG: "#73d1ff", mainBG: "#c4ebff" };
  } else if (department.includes(departments.powerEngineering)) {
    return { linerColor: "#FF0000", linerBG: "#ffadad", mainBG: "#ffecec" };
  } else if (department.includes(departments.petroleumEngineering)) {
    return { linerColor: "#FFAE14", linerBG: "#FFAE14", mainBG: "#c4ebff" };
  } else if (department.includes(departments.mechanicalEngineering)) {
    return { linerColor: "#027A48", linerBG: "#027A48" };
  } else if (department.includes(departments.informationTechnology)) {
    return { linerColor: "#3BA7E1", linerBG: "#ccedff", mainBG: "#edf9ff" };
  } else if (department.includes(departments.mbbs)) {
    return { linerColor: "#F05050", linerBG: "#F05050" };
  } else if (department.includes(departments.civilEngineering)) {
    return { linerColor: "#FFCA0E", linerBG: "#FFCA0E" };
  } else {
    return { linerColor: "#ffc700", linerBG: "#ffeeb1", mainBG: "#fffbea" };
  }
}
